import { useCallback } from 'react';

import AnalyticsService from 'services/Analytics';

import type { PageView, PageOpen, FireEvent, UseAnalytics, PushDataLayer } from 'types/analytics';

// !!TODO::: make isInitialized global

// This file has previously been written with wrong architecture
// not to refactor all the files and keep the interface the same we decided to keep the interface and
// write a wrapper on top of it which is AnalyticsService

const useAnalytics = (): UseAnalytics => {
  const pushDataLayer: PushDataLayer = useCallback(
    dataLayer => AnalyticsService.pushDataLayer(dataLayer),
    [],
  );

  const pageView: PageView = useCallback(page => AnalyticsService.pageView(page), []);

  const fireEvent: FireEvent = useCallback(async (eventName, params, interaction = true) => {
    const data = { ...params, module: 'tech-seo' };
    await AnalyticsService.fireEvent(eventName, data, interaction);
  }, []);

  const firePageOpen: PageOpen = useCallback(
    (screen, data) =>
      fireEvent(
        'page_open',
        {
          screen_name: screen,
          source: true,
          ...data,
        },
        false,
      ),
    [fireEvent],
  );

  return {
    pageView,
    firePageOpen,
    pushDataLayer,
    fireEvent,
  };
};

export default useAnalytics;
